// import React, { useState } from "react";
// import Sidebar from "../Component/Sidebar";
// import Loader from "../Component/Loader";

// const Videos = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   return (
//     <>
//       <Sidebar />
//       {isLoading ? (
//         <Loader />
//       ) : (
//         <div className="sidebody">
//           <div className="container">
//             <p className="admin_title">Video</p>
//             <div className="video-player-wrapper">
//               <div className="">

//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Videos;
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactPlayer from "react-player";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import "../Assets/Css/Videos.css";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";

const Videos = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  // Access props or location.state for video data
  const location = useLocation();
  const videoData =
    props.videoData ||
    location.state?.videoData ||
    "https://youtu.be/0hJ4F-Nj5VY?si=lQ16OsOIzXFdT-27";
  const { chapter_id, chapter_name, videos,chapter_desc } = location.state;
  // console.log("Video Data: ", videoData);
  // console.log("Video Title: ", chapter_name);
  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            <div className="mt-4">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <Link
                    to="/courses/videosList"
                    className="prevPage"
                    state={{
                      videos: videos,
                      chapter_id: chapter_id,
                      chapter_name: chapter_name,
                      chapter_desc:chapter_desc,
                      videoData: videoData,
                    }}
                  >
                    {chapter_name}
                  </Link>
                  <img
                    src={nextArrow}
                    alt="nextArrow"
                    height={40}
                    className="mt-1"
                  />
                  <p className="currentPage">{videoData.vid_title}</p>
                </ol>
              </nav>
            </div>
            {/* <p className="admin_title">Video</p> */}
            <div className="video-player-wrapper">
              {/* {videoData.url ? ( */}
              {videoData.vid_path ? (
                <ReactPlayer
                  // url={"https://youtu.be/0hJ4F-Nj5VY?si=lQ16OsOIzXFdT-27"}
                  url={videoData.vid_path}
                  // url={videoData.url}
                  controls
                  playing={true}
                  // width="100%"
                  // height="100%"
                />
              ) : (
                <p>No video available</p>
              )}
            </div>
            <div className="video-info">
              <h3 className="mb-4">{videoData.vid_title || "Untitled Video"}</h3>
              <p>{videoData.vid_description || "No description available"}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Videos;
